import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class DayBookService {

  private readonly savedState$ = new BehaviorSubject<any>(null);

  constructor(private readonly http: HttpClient) { }

  setSavedDayBookDate(state: any) {
    this.savedState$.next(state);
  }

  getSavedDayBookDate(): Observable<any> {
    return this.savedState$.asObservable();
  }

  clearSavedDayBookDate() {
    this.savedState$.next(null);
  }

  getHighlights(payload: any) {
    let url = environment.BASE_URL + '/v1/day-book/sales-service-summary';
    return this.http.get(url, { params: payload });
  }

  getSalesStats(payload: any) {
    let url = environment.BASE_URL + '/v1/day-book/sales-search-summary';
    return this.http.get(url, { params: payload });
  }

  getBranchSales(payload: any) {
    let url = environment.BASE_URL + '/v1/day-book/sales-by-branch-summary';
    return this.http.get(url, { params: payload });
  }

  getAllSales(payload: any) {
    let url = environment.BASE_URL + '/v1/day-book/day-sales';
    return this.http.get(url, { params: payload });
  }

  getExpenses(payload: any) {
    let url = environment.BASE_URL + '/v1/day-book/expenses-summary';
    return this.http.get(url, { params: payload });
  }

  getServices(payload: any) {
    let url = environment.BASE_URL + '/v1/day-book/services-summary';
    return this.http.get(url, { params: payload });
  }

  getStockMovementStats(payload: any) {
    let url = environment.BASE_URL + '/v1/day-book/stock-summary';
    return this.http.get(url, { params: payload });
  }

  getPurchasedata(payload: any) {
    let url = environment.BASE_URL + '/v1/day-book/purchases-summary';
    return this.http.get(url, { params: payload });
  }

  getNegativeStock(payload: any) {
    let url = environment.BASE_URL + '/v1/company-stock/negative-stock';
    return this.http.get(url, { params: payload });
  }

  getPayments(payload: any) {
    let url = environment.BASE_URL + '/v1/day-book/payment-summary';
    return this.http.get(url, { params: payload });
  }

  getLowStock(params: any) {
    let url = environment.BASE_URL + '/v1/day-book/low-stock';
    return this.http.get(url, { params: params });
  }

  exportDayBook(params: any) {
    let url = environment.BASE_URL + '/v1/day-book/download-pdf';
    return this.http.post(url, {}, { params: params });
  }

  getExportList(payload?: any) {
    let url = environment.BASE_URL + '/v1/day-book/downloads';
    return this.http.get(url, { params: payload });
  }
  
  getDayReturnsToDealers(params: any) {
    let url = environment.BASE_URL + '/v1/day-book/return-to-dealer';
    return this.http.get(url, { params: params });
  }
  
  getDayReturnsFromCustomer(params: any) {
    let url = environment.BASE_URL + '/v1/day-book/return-from-customer';
    return this.http.get(url, { params: params });
  }

  getStockmovementList(params: any) {
    let url = environment.BASE_URL + '/v1/day-book/stock-movement-list';
    return this.http.get(url, { params: params });
  }

  getTransfersFromBranch(params: any) {
    let url = environment.BASE_URL + '/v1/day-book/transfer-from-branch';
    return this.http.get(url, { params: params });
  }

  getTransfersToBranch(params: any) {
    let url = environment.BASE_URL + '/v1/day-book/transfer-to-branch';
    return this.http.get(url, { params: params });
  }

  getCashSummary(params: any) {
    let url = environment.BASE_URL + '/v1/day-book/cash-summary';
    return this.http.get(url, { params: params });
  }

  getCashSummaryList(params: any) {
    let url = environment.BASE_URL + '/v1/day-book/cash-summary-list';
    return this.http.get(url, { params: params });
  }

  getCreditsSummary(params: any) {
    let url = environment.BASE_URL + '/v1/day-book/credit-payment-summary';
    return this.http.get(url, { params: params });
  }

}
